
import axios from 'axios';
import { createAction } from "@reduxjs/toolkit";
import { takeEvery, call, put } from "redux-saga/effects";
import { COPYING_ENTITY_FAILED, COPYING_ENTITY_REQUEST, COPYING_ENTITY_SUCCEEDED, MOVING_ENTITY_FAILED, MOVING_ENTITY_REQUEST, MOVING_ENTITY_SUCCEEDED } from './actionTypes';
import { CopyEntitiesErrorResponse, CopyEntitiesRequest, CopyEntitiesResponse, MoveEntitiesErrorResponse, MoveEntitiesRequest, MoveEntitiesResponse } from 'src/types/entities';
  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  const ENTITY_BASE_URL = `${apiUrl}/api/2.0/entities`;
  

  //copy entities

  export const copyEntities = createAction<CopyEntitiesRequest>(COPYING_ENTITY_REQUEST);

  const copyingEntitiesSuccedded = createAction<CopyEntitiesResponse>(COPYING_ENTITY_SUCCEEDED);

  const copyingEntitiesFailed = createAction<CopyEntitiesErrorResponse>(COPYING_ENTITY_FAILED);

  const copyEntitiesSaga = function* (action: ReturnType<typeof copyEntities>): any {
    const request = action.payload.request;
  
    const copyEntitiesAPI = () => {
      return axios({
        method: 'PUT',
        url: `${ENTITY_BASE_URL}/copy`,
        data: request
      }).then((response) => response.data);
    };
  
    try {
      const response = yield call(copyEntitiesAPI);
      yield put(copyingEntitiesSuccedded(response));
    } catch (error) {
      yield put(copyingEntitiesFailed({error}));
    }
  };

  //move entities 
  export const moveEntities = createAction<MoveEntitiesRequest>(MOVING_ENTITY_REQUEST);

  const movingEntitiesSuccedded = createAction<MoveEntitiesResponse>(MOVING_ENTITY_SUCCEEDED);

  const movingEntitiesFailed = createAction<MoveEntitiesErrorResponse>(MOVING_ENTITY_FAILED);

  const moveEntitiesSaga = function* (action: ReturnType<typeof moveEntities>): any {
    const request = action.payload.request;
  
    const moveEntitiesAPI = () => {
      return axios({
        method: 'PUT',
        url: `${ENTITY_BASE_URL}/move`,
        data: request
      }).then((response) => response.data);
    };
  
    try {
      const response = yield call(moveEntitiesAPI);
      yield put(movingEntitiesSuccedded({response, entities: request.entities, source: request.source}));
    } catch (error) {
      yield put(movingEntitiesFailed({error}));
    }
  };


  export default function* entitiesSaga(){
    yield takeEvery(COPYING_ENTITY_REQUEST, copyEntitiesSaga);
    yield takeEvery(MOVING_ENTITY_REQUEST, moveEntitiesSaga);
  }